/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_ServerInputs */

const es_co2_error_server = /** @type {(inputs: Error_ServerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuvimos un problema en el servidor. Intenta más tarde.`)
};

/**

* @param {Error_ServerInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_server = /** @type {((inputs?: Error_ServerInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ServerInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_server(inputs)
});